export {
  Table,
  type TableColumn,
  type TableProps,
} from "./Table.component";
